import React from "react";

import { api } from "api";
import { useAppDispatch } from "store";
import { Iterable, ICategoryTag } from "types";
import { setCategories } from "store/categories";

import { useToast } from "../use-toast";

type Props = {
  onlyPublicCategories?: boolean;
};

export const useCategoryTags = ({ onlyPublicCategories = false }: Props) => {
  const { handleFirebaseError } = useToast();

  const [loading, setLoading] = React.useState(false);
  const [data, setData] = React.useState<Iterable<ICategoryTag>[]>([]);

  const fetch = React.useCallback(async () => {
    try {
      setLoading(true);
      const documents = await api.firestore.categoryTags.list({
        onlyPublicCategories,
      });
      setData(documents);
    } catch (error) {
      setData([]);
      handleFirebaseError(error);
    } finally {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onlyPublicCategories]);

  React.useEffect(() => {
    void fetch();
  }, [fetch]);

  return { loading, data } as const;
};

export const useReduxCategories = (props: Props) => {
  const dispatch = useAppDispatch();
  const { loading, data } = useCategoryTags(props);

  React.useEffect(() => {
    dispatch(setCategories(data));
  }, [data, dispatch]);

  return { loading } as const;
};
